import apiService from './api';
class NotificationsService {
    // Obter configuração atual
    async getConfig() {
        const response = await apiService.get('/notifications/config');
        return response.data;
    }
    // Atualizar configuração
    async updateConfig(config) {
        const response = await apiService.put('/notifications/config', config);
        return response.data;
    }
    // Obter configuração padrão
    async getDefaultConfig() {
        const response = await apiService.get('/notifications/config/default');
        return response.data;
    }
    // Resetar configuração
    async resetConfig() {
        const response = await apiService.post('/notifications/config/reset');
        return response.data;
    }
    // Testar configuração
    async testConfiguration(params) {
        const response = await apiService.post('/notifications/config/test', params);
        return response.data;
    }
    // Obter estatísticas
    async getStats() {
        const response = await apiService.get('/notifications/stats');
        return response.data;
    }
    // Enviar notificação manual
    async sendNotification(params) {
        const response = await apiService.post('/notifications/send', params);
        return response.data;
    }
    // Presets de provedores de email
    getEmailProviders() {
        return {
            gmail: {
                host: 'smtp.gmail.com',
                port: 587,
                secure: false
            },
            outlook: {
                host: 'smtp-mail.outlook.com',
                port: 587,
                secure: false
            },
            yahoo: {
                host: 'smtp.mail.yahoo.com',
                port: 587,
                secure: false
            },
            sapo: {
                host: 'smtp.sapo.pt',
                port: 587,
                secure: false
            },
            clix: {
                host: 'smtp.clix.pt',
                port: 587,
                secure: false
            },
            custom: {
                host: '',
                port: 587,
                secure: false
            }
        };
    }
    // Validar configuração de email
    validateEmailConfig(config) {
        const errors = [];
        if (config.enabled) {
            if (!config.host)
                errors.push('Host é obrigatório');
            if (!config.user)
                errors.push('Usuário é obrigatório');
            if (!config.password)
                errors.push('Senha é obrigatória');
            if (!config.fromEmail)
                errors.push('Email de origem é obrigatório');
            if (!config.fromName)
                errors.push('Nome de origem é obrigatório');
            if (config.fromEmail && !this.isValidEmail(config.fromEmail)) {
                errors.push('Email de origem inválido');
            }
        }
        return errors;
    }
    // Validar configuração de WhatsApp
    validateWhatsAppConfig(config) {
        const errors = [];
        if (config.enabled) {
            if (!config.provider) {
                errors.push('Provedor do WhatsApp é obrigatório');
            }
            else {
                switch (config.provider) {
                    case 'MYZAP':
                        if (!config.myzap?.baseUrl)
                            errors.push('URL da API MyZap é obrigatória');
                        if (!config.myzap?.instanceId)
                            errors.push('ID da instância MyZap é obrigatório');
                        if (!config.myzap?.token)
                            errors.push('Token MyZap é obrigatório');
                        break;
                    case 'WHATSAPP_WEB':
                        // WhatsApp Web não requer configuração específica
                        break;
                }
            }
            if (config.phoneNumber && !this.isValidPhoneNumber(config.phoneNumber)) {
                errors.push('Número do WhatsApp inválido');
            }
        }
        return errors;
    }
    // Validar configuração da empresa
    validateEmpresaConfig(config) {
        const errors = [];
        if (!config.nome)
            errors.push('Nome da empresa é obrigatório');
        if (!config.telefone)
            errors.push('Telefone da empresa é obrigatório');
        if (config.email && !this.isValidEmail(config.email)) {
            errors.push('Email da empresa inválido');
        }
        if (config.website && !this.isValidUrl(config.website)) {
            errors.push('Website da empresa inválido');
        }
        return errors;
    }
    // Validar email
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    // Validar número de telefone
    isValidPhoneNumber(phone) {
        // Aceitar formato +351XXXXXXXXX ou whatsapp:+351XXXXXXXXX
        const phoneRegex = /^(whatsapp:)?\+?[1-9]\d{1,14}$/;
        return phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''));
    }
    // Validar URL
    isValidUrl(url) {
        try {
            new URL(url);
            return true;
        }
        catch {
            return false;
        }
    }
    // Formatar número do WhatsApp
    formatWhatsAppNumber(phone) {
        let cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
        if (cleanPhone.startsWith('whatsapp:')) {
            return cleanPhone;
        }
        if (!cleanPhone.startsWith('+')) {
            if (cleanPhone.length === 9 && cleanPhone.match(/^[29]/)) {
                cleanPhone = '+351' + cleanPhone;
            }
            else if (cleanPhone.length === 12 && cleanPhone.startsWith('351')) {
                cleanPhone = '+' + cleanPhone;
            }
        }
        return `whatsapp:${cleanPhone}`;
    }
    // Obter tipos de notificação
    getNotificationTypes() {
        return [
            {
                key: 'ordemServicoAberta',
                label: 'Ordem de Serviço Aberta',
                description: 'Quando uma nova ordem de serviço é criada'
            },
            {
                key: 'ordemServicoOrcamentoAprovado',
                label: 'Orçamento Aprovado',
                description: 'Quando um orçamento é aprovado pelo cliente'
            },
            {
                key: 'ordemServicoConcluida',
                label: 'Reparação Concluída',
                description: 'Quando uma reparação é concluída'
            },
            {
                key: 'ordemServicoEntregue',
                label: 'Equipamento Entregue',
                description: 'Quando um equipamento é entregue ao cliente'
            },
            {
                key: 'vendaRealizada',
                label: 'Venda Realizada',
                description: 'Quando uma venda é finalizada'
            },
            {
                key: 'lembreteOrcamento',
                label: 'Lembrete de Orçamento',
                description: 'Lembrete para orçamentos pendentes'
            },
            {
                key: 'lembreteEntrega',
                label: 'Lembrete de Entrega',
                description: 'Lembrete para equipamentos prontos'
            }
        ];
    }
    // Enviar notificação específica de ordem de serviço
    async sendOrdemServicoNotification(ordemServicoId, tipoEvento) {
        const response = await apiService.post(`/ordens-servico/${ordemServicoId}/notify`, {
            tipoEvento
        });
        return response.data;
    }
    // Enviar notificação específica de orçamento
    async sendOrcamentoNotification(orcamentoId, tipoEvento) {
        const response = await apiService.post(`/orcamentos/${orcamentoId}/notify`, {
            tipoEvento
        });
        return response.data;
    }
    // Obter templates de mensagens personalizados
    async getTemplates() {
        const response = await apiService.get('/notifications/templates');
        return response.data || [];
    }
    // Salvar templates de mensagens
    async saveTemplates(templates) {
        const response = await apiService.post('/notifications/templates', {
            templates
        });
        return response.data;
    }
    // Enviar notificação manual usando template
    async sendManualNotification(params) {
        const response = await apiService.post('/notifications/send-manual', params);
        return response.data;
    }
}
// Instância singleton
const notificationsService = new NotificationsService();
export default notificationsService;
